import React from "react";
import ViewCartLink from "./ViewCartLink";

interface PrintLightboxHeaderProps {
  primaryColor?: string;
  hasCartItems?: boolean;
  cartId?: number;
  isEmbed?: boolean;
}

const PrintLightboxHeader: React.FC<PrintLightboxHeaderProps> = ({
  primaryColor = "#259fa5",
  hasCartItems = false,
  cartId,
  isEmbed = false
}) => {
  return (
    <div className="geo-print-head-div">
      <div className="geo-print-head-div-text">
        {/* Header text */}
        <div className="geo-print-head-div__header">
          <div className="geo-print-head-div__text">
            Select the products that you want to buy
          </div>
        </div>

        {/* Action row - only show View Cart when there are items in cart */}
        <div>
          {hasCartItems && cartId && (
            <ViewCartLink
              cartId={cartId}
              isEmbed={isEmbed}
              parentName="print-lightbox-footer"
              primaryColor={primaryColor}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PrintLightboxHeader;
